module.exports = __webpack_public_path__ + "static/media/Stellar Vox Queen Headboard - 155 cm_Cream.a34514dd.png";